import { gql } from "@apollo/client";

export const GET_ACCOUNTS_NAME = "GetAccountsQuery";
export const GET_ACCOUNTS_QUERY = gql`
  query ${GET_ACCOUNTS_NAME} (
  $search: String
  $first: Int = 25
  $cursor: String
  $with_cert: Boolean!
  $with_ott: Boolean!
  ) {
    ipmp_accounts(search: $search, first: $first, after: $cursor) {
      edges {
        node {
          id_ipmp
          name
          ipmp_user
          pmn_amount
          description
          enabled
          license {
           name
          }
          certificates @include(if: $with_cert) {
            id_cert
            type
            expired
          }
          ott @include(if: $with_ott) {
            pmn_id
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const GET_ACCOUNT_NAME = "GetAccountQuery";
export const GET_ACCOUNT_QUERY = gql`
  query ${GET_ACCOUNT_NAME}($id_ipmp: Int!) {
    ipmp_account(id_ipmp: $id_ipmp) {
      id_ipmp
      name
      enabled
    }
  }
`;

export const ADD_ACCOUNT_NAME = "AddAccount";
export const ADD_ACCOUNT = gql`
  mutation ${ADD_ACCOUNT_NAME}(
    $description: String!
    $enabled: Boolean!
    $name: String!
    $ipmp_user: String!
    $password: String!
    $pmn_amount: Int!
  ) {
    create_ipmp(
      description: $description
      enabled: $enabled
      name: $name
      ipmp_user: $ipmp_user
      pmn_amount: $pmn_amount
      password: $password
    ) {
      success
      message
    }
  }
`;

export const UPDATE_ACCOUNT_NAME = "EditAccount";
export const UPDATE_ACCOUNT = gql`
  mutation ${UPDATE_ACCOUNT_NAME}(
    $id_ipmp: Int!
    $description: String
    $enabled: Boolean
    $name: String
    $password: String
    $pmn_amount: Int
  ) {
    update_ipmp(
      id_ipmp: $id_ipmp
      description: $description
      enabled: $enabled
      name: $name
      pmn_amount: $pmn_amount
      password: $password
    ) {
      success
      message
    }
  }
`;

export const DELETE_ACCOUNT_NAME = "DeleteAccount";
export const DELETE_ACCOUNT = gql`
  mutation ${DELETE_ACCOUNT_NAME}($ids: [Int!]!) {
    delete_ipmp(ids: $ids) {
      success
      message
    }
  }
`;

export const GET_REGISTERED_SERVERS_NAME = "GetRegisteredServers";
export const GET_REGISTERED_SERVERS_QUERY = gql`
  query ${GET_REGISTERED_SERVERS_NAME} ($id_ipmp: Int!) {
    ipmp_account(id_ipmp: $id_ipmp) {
      ott {
        pmn_id
        ipmp_hostname
        ipmp_version
        updated_at
        force_sync
      }
    }
  }
`;

export const FORCE_SYNC_REGISTERED_SERVER = gql`
  mutation ForceSyncRegisteredServer(
    $pmn_ids: [String]!
    $force_sync: Boolean!
  ) {
    set_force_sync(pmn_ids: $pmn_ids, force_sync: $force_sync) {
      success
      message
    }
  }
`;

export const UPDATE_REGISTERED_SERVER_NAME = "UpdateRegisteredServer";
export const UPDATE_REGISTERED_SERVER = gql`
  mutation ${UPDATE_REGISTERED_SERVER_NAME}($ids: [String]!) {
    update_ott(ids: $ids) {
      success
      message
    }
  }
`;

export const DELETE_REGISTERED_SERVER_NAME = "DeleteRegisteredServer";
export const DELETE_REGISTERED_SERVER = gql`
  mutation ${DELETE_REGISTERED_SERVER_NAME}($ids: [String!]) {
    delete_ott(pmn_ids: $ids) {
      success
      message
    }
  }
`;

const APNS_CENTER_FRAGMENT = gql`
  fragment APNSCentersQueryFragment on CentersQuery {
    apns(first: $first, after: $cursor) {
      edges {
        node {
          description
          id_center
          name
          type
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

const FCM_CENTER_FRAGMENT = gql`
  fragment FCMCentersQueryFragment on CentersQuery {
    fcm(first: $first, after: $cursor) {
      edges {
        node {
          description
          id_center
          name
          type
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

const ASSIGNED_PUSH_CENTERS = gql`
  fragment IpmpAssignedCentersFragment on IpmpAccounts {
    centers {
      id_center
    }
  }
`;

export const READ_ACCOUNT_APNS_PUSH_CENTERS_NAME = "GetAccountAPNSPushCenters";
export const READ_ACCOUNT_APNS_PUSH_CENTERS_QUERY = gql`
  ${APNS_CENTER_FRAGMENT}
  ${ASSIGNED_PUSH_CENTERS}
  query ${READ_ACCOUNT_APNS_PUSH_CENTERS_NAME} (
    $id_ipmp: Int!
    $first: Int = 15
    $cursor: String
    ) {
    ipmp_account(id_ipmp: $id_ipmp) {
      ...IpmpAssignedCentersFragment
    }
    fcm_apns_centers{
      ...APNSCentersQueryFragment
    }
  }
`;

export const READ_ACCOUNT_FCM_PUSH_CENTERS_NAME = "GetAccountFCMPushCenters";
export const READ_ACCOUNT_FCM_PUSH_CENTERS_QUERY = gql`
  ${FCM_CENTER_FRAGMENT}
  ${ASSIGNED_PUSH_CENTERS}
  query ${READ_ACCOUNT_FCM_PUSH_CENTERS_NAME} (
    $id_ipmp: Int!
    $first: Int = 15
    $cursor: String
    ) {
    ipmp_account(id_ipmp: $id_ipmp) {
      ...IpmpAssignedCentersFragment
    }
    fcm_apns_centers{
      ...FCMCentersQueryFragment
    }
  }
`;

export const ASSIGN_PUSH_CENTER = gql`
  mutation AssignPushCenter($center_ids: [Int!], $id_ipmp: [Int!]) {
    create_assign_center(center_ids: $center_ids, id_ipmp: $id_ipmp) {
      success
      message
    }
  }
`;

export const UNASSIGN_PUSH_CENTER = gql`
  mutation UnassignPushCenter($center_ids: [Int!], $id_ipmp: [Int!]) {
    delete_assign_center(center_ids: $center_ids, id_ipmp: $id_ipmp) {
      success
      message
    }
  }
`;

const ACCOUNT_PACKAGES_FIELDS = gql`
  fragment AccountPackagesFields on IpmpAccounts {
    upgrade_packages {
      id_package
    }
  }
`;

const PACKAGES_FIELDS = gql`
  fragment PackagesFields on TUpgradePackagesNodeConnection {
    edges {
      node {
        id_package
        meta
        package_name
        package_type
      }
    }
  }
`;

export const GET_ACCOUNT_PLINK_PACKAGES_NAME = "GetAccountPlinkPackages";
export const GET_ACCOUNT_PLINK_PACKAGES_QUERY = gql`
  ${ACCOUNT_PACKAGES_FIELDS}
  ${PACKAGES_FIELDS}
  query ${GET_ACCOUNT_PLINK_PACKAGES_NAME} ($id_ipmp: Int!) {
  ipmp_account(id_ipmp: $id_ipmp) {
    ...AccountPackagesFields
  }
  packages {
    list(package_type: PLINK) {
      ...PackagesFields
    }
  }
}
`;

export const GET_ACCOUNT_PMAX_PACKAGES_NAME = "GetAccountPmaxPackages";
export const GET_ACCOUNT_PMAX_PACKAGES_QUERY = gql`
  ${ACCOUNT_PACKAGES_FIELDS}
  ${PACKAGES_FIELDS}
  query ${GET_ACCOUNT_PMAX_PACKAGES_NAME} ($id_ipmp: Int!) {
  ipmp_account(id_ipmp: $id_ipmp) {
    ...AccountPackagesFields
  }
  packages {
    list(package_type: PMAX) {
      ...PackagesFields
    }
  }
}
`;

export const GET_ACCOUNT_OTA_PACKAGES_NAME = "GetAccountOTAPackages";
export const GET_ACCOUNT_OTA_PACKAGES_QUERY = gql`
  ${ACCOUNT_PACKAGES_FIELDS}
  ${PACKAGES_FIELDS}
  query ${GET_ACCOUNT_OTA_PACKAGES_NAME} ($id_ipmp: Int!) {
  ipmp_account(id_ipmp: $id_ipmp) {
    ...AccountPackagesFields
  }
  packages {
    list(package_type: OTA) {
      ...PackagesFields
    }
  }
}
`;

export const GET_ACCOUNT_SC_PACKAGES_NAME = "GetAccountSCPackages";
export const GET_ACCOUNT_SC_PACKAGES_QUERY = gql`
  ${ACCOUNT_PACKAGES_FIELDS}
  ${PACKAGES_FIELDS}
  query ${GET_ACCOUNT_SC_PACKAGES_NAME} ($id_ipmp: Int!) {
  ipmp_account(id_ipmp: $id_ipmp) {
    ...AccountPackagesFields
  }
  packages {
    list(package_type: SC) {
      ...PackagesFields
    }
  }
}
`;

export const READ_ACCOUNT_LICENSE_NAME = "ReadAccountLicense";
export const READ_ACCOUNT_LICENSE_QUERY = gql`
  query ${READ_ACCOUNT_LICENSE_NAME}($id_ipmp: Int!) {
    ipmp_account(id_ipmp: $id_ipmp) {
      license {
        id_license
        description
        name
        validity {
          license_renewal
          not_after
          not_before
        }
      }
    }
  }
`;

export const UPDATE_ACCOUNT_LICENCE_PERIOD_NAME = "UpdateAccountLicensePeriod";
export const UPDATE_ACCOUNT_LICENCE_PERIOD = gql`
  mutation ${UPDATE_ACCOUNT_LICENCE_PERIOD_NAME}(
    $id_ipmp: ID!
    $id_license: ID!
    $not_after: DateTime!
    $not_before: DateTime!
    $license_renewal: Boolean
  ) {
    update_license(
      id_ipmp: $id_ipmp
      id_license: $id_license
      not_after: $not_after
      not_before: $not_before
      license_renewal: $license_renewal
    ) {
      success
      message
    }
  }
`;

export const READ_ACCOUNT_DEALER_INFO_QUERY = gql`
  query ReadAccountDealerInfo($id_ipmp: Int!) {
    ipmp_account(id_ipmp: $id_ipmp) {
      dashboards {
        dealer_info {
          phone_number
          name
          dealer_id
          email_address
          address
        }
      }
    }
  }
`;

export const READ_ACCOUNT_NOTES_QUERY = gql`
  query ReadAccountNotes($id_ipmp: Int!) {
    ipmp_account(id_ipmp: $id_ipmp) {
      dashboards {
        notes {
          delete
          update
          timestamp
          text
          id_note
          user_info {
            id
            username
            first_name
            last_name
          }
        }
      }
    }
  }
`;

export const READ_ACCOUNT_DASHBOARD_PANEL_LIMITS_QUERY = gql`
  query ReadAccountDashboardPanelLimits($id_ipmp: Int!) {
    ipmp_account(id_ipmp: $id_ipmp) {
      dashboards {
        registered {
          limits {
            total
            title
            actual
            trend
          }
          server_name
          server_version
          last_sync_date
        }
      }
    }
  }
`;

export const READ_ACCOUNT_DASHBOARD_PACKAGES_QUERY = gql`
  query ReadAccountDashboardPackages($id_ipmp: Int!) {
    ipmp_account(id_ipmp: $id_ipmp) {
      dashboards {
        packages {
          total
          title
          actual
        }
      }
    }
  }
`;

export const READ_ACCOUNT_DASHBOARD_PUSH_CENTERS_QUERY = gql`
  query ReadAccountPushCenters($id_ipmp: Int!) {
    ipmp_account(id_ipmp: $id_ipmp) {
      dashboards {
        centers {
          actual
          title
          total
        }
      }
    }
  }
`;

export const READ_ACCOUNT_SYSTEM_EVENTS_QUERY = gql`
  query ReadAccountEvents($id_ipmp: Int!) {
    ipmp_account(id_ipmp: $id_ipmp) {
      system_events {
        timestamp
        template
        resource_metadata
        params
        id_sys_event
        event_type
      }
    }
  }
`;

export const READ_ACCOUNT_TOTAL_COUNTERS_QUERY = gql`
  query ReadAccountTotalInfoQuery($id_ipmp: Int!) {
    ipmp_account(id_ipmp: $id_ipmp) {
      dashboards {
        total_info {
          active_servers
          total_servers
          events {
            total
            priority
          }
        }
      }
    }
  }
`;

export const CREATE_ACCOUNT_NOTE = gql`
  mutation CreateAccountNote($id_ipmp: Int!, $text: String!) {
    create_note(id_ipmp: $id_ipmp, text: $text) {
      success
      message
    }
  }
`;

export const UPDATE_ACCOUNT_NOTE = gql`
  mutation UpdateAccountNote($id_note: Int!, $text: String!) {
    update_note(id_note: $id_note, text: $text) {
      success
      message
    }
  }
`;

export const DELETE_ACCOUNT_NOTE = gql`
  mutation DeleteAccountNote($ids: [Int!]!) {
    delete_note(ids: $ids) {
      success
      message
    }
  }
`;

export const UPDATE_ACCOUNT_DEALER_INFO = gql`
  mutation UpdateDealerInfo(
    $id_ipmp: Int!
    $address: String
    $dealer_id: String
    $email_address: String
    $name: String
    $phone_number: String
  ) {
    update_dealer_info(
      id_ipmp: $id_ipmp
      address: $address
      dealer_id: $dealer_id
      email_address: $email_address
      name: $name
      phone_number: $phone_number
    ) {
      success
      message
    }
  }
`;
